<template>
  <div>
    <template v-if="isDiscounted(discountedAmount)">
      <el-tooltip class="item" effect="dark" placement="left"
                  :content="`Discount amount ${currency(discountedAmount)}`">
        <small>
          <del class="text-info">{{ originalPrice | currency }}</del>
        </small>
      </el-tooltip>
      <span>{{ updatePrice | currency }}</span>
    </template>
    <template v-else>
      {{ updatePrice | currency }}
    </template>
  </div>
</template>

<script>
import {currency} from '../../../filters';

export default {
  name: 'PriceDisplay',
  props: {
    originalPrice: {
      type: Number,
    },
    updatePrice: {
      type: Number,
    },
  },
  filters: {
    currency,
  },
  computed: {
    discountedAmount() {
      return this.originalPrice - this.updatePrice;
    },
  },
  methods: {
    isDiscounted(discountedAmount) {
      return discountedAmount > 0;
    },
    currency,
  },
};
</script>
